import { IAgentSchema, INewObjectBuilderSchema, IOfferSchema } from '@cian/api-models/offer-card/v1/get-offer-data';

import { getMasterAgentId } from './getMasterAgentId';
import { isFromBuilder } from './agent';

export function getFullProfileLink(
  agent: IAgentSchema | null,
  offer: IOfferSchema,
  developer: INewObjectBuilderSchema | null,
) {
  if (isFromBuilder(offer) && developer && developer.url) {
    return developer.url;
  }

  if (agent) {
    if (agent.isSubAgent) {
      const masterAgentId = agent.masterAgent ? getMasterAgentId(agent.masterAgent) : agent.parentId;

      return `/company/${masterAgentId}`;
    }

    if (agent.accountType === 'specialist') {
      return `/agents/${agent.id}`;
    }

    if (agent.offersLink) {
      return agent.offersLink;
    }
  }

  return undefined;
}
